// src/services/extension.js
// The content script answers `michii:detect` with `michii:ready` on any Michii
// origin, so any page (not just /play) can detect the extension and launch playback.

const DETECT_TIMEOUT_MS = 400;

export function detectExtension() {
  return new Promise((resolve) => {
    const timer = setTimeout(() => resolve(false), DETECT_TIMEOUT_MS);
    window.addEventListener('michii:ready', () => {
      clearTimeout(timer);
      resolve(true);
    }, { once: true });
    window.dispatchEvent(new CustomEvent('michii:detect'));
  });
}

export function playWithExtension(guide) {
  window.dispatchEvent(new CustomEvent('michii:play', {
    detail: {
      guideId:   guide.id,
      guideName: guide.name,
      startUrl:  guide.start_url,
      steps:     guide.steps,
    },
  }));
}

export function getDomain(url) {
  try { return new URL(url).hostname; } catch { return url; }
}

// The recorder already scales the rect by devicePixelRatio (content.js
// scaleBboxByDpr), so it is in the same pixel space as the screenshot — no
// conversion, just px → % of the image. Returns null when coords are unknown.
export function highlightRect(step, natural) {
  const b = step?.target?.vision?.bbox;
  const x = b?.x      ?? step?.highlight_x;
  const y = b?.y      ?? step?.highlight_y;
  const w = b?.width  ?? step?.highlight_width;
  const h = b?.height ?? step?.highlight_height;
  if (![x, y, w, h].every(n => typeof n === 'number') || w <= 0 || h <= 0) return null;
  if (!natural?.w || !natural?.h) return null;

  return {
    left:   (x / natural.w) * 100,
    top:    (y / natural.h) * 100,
    width:  (w / natural.w) * 100,
    height: (h / natural.h) * 100,
  };
}
